import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';
import { ComponentStyle } from '../theme';

/**
 * This Global Style must be applied to use the component library correctly
 */
const GlobalStyle = createGlobalStyle`
  ${normalize}

  * {
    box-sizing: border-box;
  }

  ${({ theme }): ComponentStyle => theme?.global};
`;

export default GlobalStyle;
